import { render, staticRenderFns } from "./ReportTableClassicLinkedIn.vue?vue&type=template&id=710bbde2&"
import script from "./ReportTableClassicLinkedIn.vue?vue&type=script&lang=js&"
export * from "./ReportTableClassicLinkedIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports